<template>
  <div class="pcga-tab">
    <vxe-toolbar size="small" perfect :export="true" :refresh="{ query: loadData }" :print="true">
      <template #buttons>
        <vxe-input
          v-model="key_w"
          type="search"
          placeholder="Search table"
          @keyup="searchEvent"
        ></vxe-input>
      </template>
    </vxe-toolbar>
    <vxe-table
      row-id="id"
      :loading="loading"
      :data="list1"
      style="font-family: Arial, Helvetica, sans-serif;color:#000000"
      size="small"
      border="full"
      max-height="500"
      :export-config="{}"
      :query="loadData"
    >
      <vxe-table-column
        v-for="col in table_data.tableColumn"
        :key="col.field"
        :field="col.field"
        :title="col.title"
        :width="col.width"
        :title-help="col.msg"
        :sortable="col.sort"
        type="html"
      ></vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.totalResult"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="handletablePageChange"
      style="font-family: Arial, Helvetica, sans-serif;color:#000000"
      size="small"
      :page-sizes="[10, 20, 100, {label: 'Full', value: -1}]"
      perfect
    ></vxe-pager>
  </div>
</template>

<script>
import XEUtils from 'xe-utils'
export default {
  // props: ["table_data", "loading"],
  data: function () {
    return {
      loading:false,
      list1:[],
      key_w:'',
      filterTableData:[],
      tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 10,
        },
      table_data:{
        tableColumn: [
          { field: 'address', title: 'Address' },
          { field: 'role', title: 'role' },
          { field: 'sex', title: 'sex' },
          { field: 'age', title: 'age' }
        ],
        tableData: [],
      }
    }
  },
  created() {
    // this.loadData()
    // this.searchEvent()
  },
  mounted: function () {
  },

  watch: {
  },
  methods: {
    loadData() {
      console.log('load data')
      this.table_data.tableData = [
        { id: 10001, name: 'Test1', nickname: 'T1', role: 'Develop', sex: 'Man', age: 28, address: 'Shenzhen' },
        { id: 10002, name: 'Test2', nickname: 'T2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
        { id: 10003, name: 'Test3', nickname: 'T3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
        { id: 10004, name: 'Test4', nickname: 'T4', role: 'Designer', sex: 'Women', age: 23, address: 'Shenzhen' },
        { id: 10005, name: 'Test5', nickname: 'T5', role: 'Develop', sex: 'Women', age: 30, address: 'Shanghai' },
        { id: 10006, name: 'Test6', nickname: 'T6', role: 'Designer', sex: 'Women', age: 21, address: 'Shenzhen' },
        { id: 10007, name: 'Test7', nickname: 'T7', role: 'Test', sex: 'Man', age: 29, address: 'Guangzhou' },
        { id: 10008, name: 'Test8', nickname: 'T8', role: 'Develop', sex: 'Man', age: 35, address: 'Shenzhen' },
        { id: 10009, name: 'Test9', nickname: 'T9', role: 'Test', sex: 'Man', age: 24, address: 'Shenzhen' },
        { id: 100010, name: 'Test10', nickname: 'T10', role: 'Develop', sex: 'Man', age: 20, address: 'Guangzhou' },
        { id: 10001, name: 'Test1', nickname: 'T1', role: 'Develop', sex: 'Man', age: 28, address: 'Shenzhen' },
        { id: 10002, name: 'Test2', nickname: 'T2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
        { id: 10003, name: 'Test3', nickname: 'T3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
        { id: 10004, name: 'Test4', nickname: 'T4', role: 'Designer', sex: 'Women', age: 23, address: 'Shenzhen' },
        { id: 10005, name: 'Test5', nickname: 'T5', role: 'Develop', sex: 'Women', age: 30, address: 'Shanghai' },
        { id: 10006, name: 'Test6', nickname: 'T6', role: 'Designer', sex: 'Women', age: 21, address: 'Shenzhen' },
        { id: 10007, name: 'Test7', nickname: 'T7', role: 'Test', sex: 'Man', age: 29, address: 'Guangzhou' },
        { id: 10008, name: 'Test8', nickname: 'T8', role: 'Develop', sex: 'Man', age: 35, address: 'Shenzhen' },
        { id: 10009, name: 'Test9', nickname: 'T9', role: 'Test', sex: 'Man', age: 24, address: 'Shenzhen' },
        { id: 100010, name: 'Test10', nickname: 'T10', role: 'Develop', sex: 'Man', age: 22, address: 'Guangzhou' }
      ];
      this.filterTableData=this.table_data.tableData;
      this.getCurrentTable();
    },
    searchEvent() {
      const filterName = XEUtils.toValueString(this.key_w).trim().toLowerCase()
      console.log(filterName)
      if (filterName) {
        const filterRE = new RegExp(filterName, 'gi')
        var searchProps = [];
        for(var k in this.table_data.tableData[0]){
          searchProps.push(k);
        }
        const rest = this.table_data.tableData.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
        this.filterTableData = rest.map(row => {
          const item = Object.assign({}, row)
          searchProps.forEach(key => {
            item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)
          })
          return item
        })
      } else {
        this.filterTableData =this.table_data.tableData
      }
      this.tablePage.currentPage=1;
      this.getCurrentTable();
    },
    handletablePageChange ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.loading = false
      this.getCurrentTable();
      console.log(this.list1);
    },
    getCurrentTable(){
      this.tablePage.totalResult = this.filterTableData.length
      if(this.tablePage.pageSize==-1){
        this.list1 = this.filterTableData;
      }else{
        this.list1 = this.filterTableData.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize);
      }
    }
  }
}
</script>



<style>
.vxe-table--render-default.size--mini .vxe-body--column:not(.col--ellipsis) {
  padding: 4px 0;
}

.vxe-table--render-default.size--small .vxe-body--column:not(.col--ellipsis) {
  padding: 6px 0;
}

.keyword-lighten {
  color: #000;
  background-color: #ffc400;
}
</style>



// WEBPACK FOOTER //
// src/components/test/test.vue